module.exports = __webpack_public_path__ + "static/elsaM_screen01-796a5fbb7501044d5f051776ecdee3fe.jpg";